import React from 'react'

const Saved = () => {
    return (
            <div className="mainside">
        <div className="container">
        <div>
            Saved
        </div>
        </div>
        </div>
    )
}

export default Saved
